import { notification } from "antd";
import "antd/dist/antd.css";

export const openErrorNotification = () => {
    notification.error({
        message: "Что-то пошло не так!",
        description: "Кажется, ошибка с нашей стороны. Попробуйте позднее еще раз или свяжитесь с поддержкой.",
        placement: 'topLeft',
    });
};